import GenerateCampaignModalLayout from "../../GenerateCampaign/GenerateCampaignModalLayout";
import GenerateCampaignFormMeta from "./GenerateCampaignFormMeta";

const GenerateCampaignMeta = ({
  initialData = {},
  modalOpen,
  onCloseModal,
  campaignID,
  context,
  onCallbackSave = () => {},
  verifyBlockAlert = true,
}) => {
  return (
    <GenerateCampaignModalLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
    >
      <GenerateCampaignFormMeta
        initialData={initialData}
        campaignID={campaignID}
        context={context}
        onCallbackSave={onCallbackSave}
        verifyBlockAlert={verifyBlockAlert}
      />
    </GenerateCampaignModalLayout>
  );
};

export default GenerateCampaignMeta;
